import React from "react";
import { Session, SessionStatuses } from "../../data/Session";

export interface SessionListProps {
  list: Session[];
  onEdit: (session: Session) => void;
}

function sessionStatusChipClass(status: string): string {
  switch (status) {
    case SessionStatuses.InSession:
      return "sl-chip-status-new";
    case SessionStatuses.Voting:
      return "sl-chip-status-voting";
    case SessionStatuses.Completed:
      return "sl-chip-status-voted";
    default:
      return "sl-chip-type";
  }
}

function SessionList({ list, onEdit }: SessionListProps) {
  return (
    <div className="table-responsive">
      <table className="table">
        <thead>
          <tr>
            <th>ID - Name</th>
            <th>Status</th>
            <th>Participant View / Buttons</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {list.map((session) => {
            return (
              <tr key={session.subId}>
                <td>
                  <span className="sl-num">{session.subId}</span> - {session.name}
                </td>
                <td>
                  <span className={`sl-chip ${sessionStatusChipClass(session.status)}`}>{session.status}</span>
                </td>
                <td>
                  {session.enableParticipantView ? "Yes" : "No"} / {session.enableParticipantButtons ? "Yes" : "No"}
                </td>
                <td>
                  <button className="btn btn-light btn-sm" onClick={() => onEdit(session)}>
                    Edit
                  </button>
                </td>
              </tr>
            );
          })}
          {list.length === 0 ? (
            <tr>
              <td colSpan={4} className="text-muted">
                No Sessions found
              </td>
            </tr>
          ) : (
            <></>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default SessionList;
